import React, { useState } from 'react'
import { EmptyState } from '../../../common/components/EmptyState/EmptyState'
import { useStyles } from './UsageMeteringEmptyState.styles'
import { SelectChangeEvent, Typography } from '@mui/material'
import {
  ButtonV2,
  CloudSelectorV2,
  ExternalLink,
} from '@labrav/react-components'
import {
  cloudTypes,
  emptyUsageMeteringUrl,
} from '../../../common/utils/meteringConstants'
import EmptyProductListing from '../../../common/images/EmptyProductListing.png'

export interface UsageMeteringEmptyStateProps {
  handleClick: () => void
}
export const UsageMeteringEmptyState: React.FC<
  UsageMeteringEmptyStateProps
> = ({ handleClick }) => {
  const { classes } = useStyles()
  const [cloud, setCloud] = useState('AWS')
  const handleChangeCloud = (event: SelectChangeEvent) => {
    setCloud(event.target.value as string)
  }
  return (
    <div data-testid="usage-metering-empty-state">
      <EmptyState
        content={
          <>
            <div className={classes.subHeadingContainer}>
              <Typography className={classes.subHeading}>
                Submit usage metering records to cloud marketplaces with ease
                using file upload, API or through a simple form.
              </Typography>
              <Typography className={classes.subHeading}>
                For more details, checkout the resources{' '}
                <ExternalLink href={emptyUsageMeteringUrl}>
                  {' '}
                  here{' '}
                </ExternalLink>{' '}
              </Typography>
            </div>
          </>
        }
        header="Start creating your first metering"
        imgSrc={EmptyProductListing}
        action={
          <>
            <div className={classes.actionsContainer}>
              <div className={classes.buttonsContainer}>
                <CloudSelectorV2
                  cloudTypes={cloudTypes}
                  selectedCloud={cloud}
                  onChange={handleChangeCloud}
                  label="Cloud"
                  minWidth={135}
                  size={'small'}
                />
              </div>
              <div>
                <ButtonV2
                  data-testid="create-metering"
                  styleType="primary"
                  onClick={handleClick}
                  disabled={false}
                >
                  Create metering
                </ButtonV2>
              </div>
            </div>
          </>
        }
      />
    </div>
  )
}
